<!-- 攻击属性 防御属性 -->
<template>
  <div>
    <tx-bg
      src="oldclassic_m_roleinfo_img_zbbiaoti_db"
      class="roleinfo-attr-title"
    >
      <span>攻击属性</span>
    </tx-bg>

    <div class="grid-2 px-24">
      <t-row
        v-for="(item, i_index) in attact_attr"
        :key="i_index"
        :title="item.text"
        titleClass="roleinfo-attr-gj-label"
        valueClass="roleinfo-attr-gj-value"
        :value="get_value(new_attributes, item.value)"
      />
    </div>

    <tx-bg
      src="oldclassic_m_roleinfo_img_zbbiaoti_db"
      class="roleinfo-attr-title"
    >
      <span>防御属性</span>
    </tx-bg>

    <div class="grid-2 px-24">
      <t-row
        v-for="(item, i_index) in def_attr"
        :key="i_index"
        :title="item.text"
        titleClass="roleinfo-attr-gj-label"
        valueClass="roleinfo-attr-gj-value"
        :value="get_value(new_attributes, item.value)"
      />
    </div>

    <tx-bg
      src="oldclassic_m_roleinfo_img_zbbiaoti_db"
      class="roleinfo-attr-title"
    >
      <span>高级属性</span>
    </tx-bg>

    <div class="grid-2 px-24">
      <t-row
        v-for="(item, i_index) in high_attr"
        :key="i_index"
        :title="item.text"
        titleClass="roleinfo-attr-gj-label"
        valueClass="roleinfo-attr-gj-value"
        :value="get_value(new_attributes, item.value)"
      />
    </div>

    <tx-bg
      src="oldclassic_m_roleinfo_img_zbbiaoti_db"
      class="roleinfo-attr-title"
    >
      <span>抗性</span>
    </tx-bg>

    <div class="grid-2 px-24">
      <t-row
        v-for="(item, i_index) in ad_attr"
        :key="i_index"
        :title="item.text"
        titleClass="roleinfo-attr-gj-label"
        valueClass="roleinfo-attr-gj-value"
        :value="get_value(new_attributes, item.value)"
      />
    </div>
  </div>
</template>
  
<script setup>
import { defineProps, ref, computed } from 'vue';

const props = defineProps({
  role_data: {
    type: Object,
    default: () => ({}),
  },
});

// 攻击属性
const attact_attr = ref([
  { text: '攻力', value: ['最小物理攻击力', '最大物理攻击力'] },
  { text: '重击', value: ['重击力'] },
  { text: '命中', value: ['命中力'] },
  { text: '会心一击', value: ['会心一击力'] },
  { text: '法力', value: ['最小魔法攻击力', '最大魔法攻击力'] },
  { text: '附加伤害', value: ['附加伤害'] },
  // { text: '诛心', value: ['cri_add_p'] },
  // { text: '万钧', value: ['thump_add_p'] },
  // { text: '破甲', value: ['破甲'] },
  // { text: '透魔', value: ['透魔'] },
  // { text: '物理破防', value: ['break_pdef_abs'] },
  // { text: '法术破防', value: ['break_mdef_abs'] },
]);

// 防御属性
const def_attr = ref([
  { text: '防御', value: ['物理防御力'] },
  { text: '回避', value: ['回避力'] },
  { text: '法防', value: ['法术防御力'] },
  { text: '神明', value: ['神明'] },
  { text: '化解', value: ['化解'] },
  { text: '知彼', value: ['知彼'] },
  // { text: '御心', value: ['cri_sub_p'] },
  // { text: '铁壁', value: ['thump_sub_p'] },
  // { text: '铁甲', value: ['ignore_pdef_buster'] },
  // { text: '仙衣', value: ['ignore_mdef_buster'] },
]);

// 抗性
const ad_attr = ref([
  { text: '身法', value: ['反应力'] },
  { text: '定力', value: ['意志力'] },
  { text: '坚韧', value: ['坚韧力'] },
]);

// 高级属性
const high_attr = ref([
  { text: '追电', value: ['追电'] },
  { text: '骤雨', value: ['骤雨'] },
  { text: '疾语', value: ['疾语'] },
  { text: '明思', value: ['明思'] },
  { text: '扰心', value: ['扰心'] },
  { text: '人祸', value: ['人祸'] },
]);

const new_attributes = computed(() => {
  return props.role_data?.new_attributes || {};
});

const get_value = (obj, valueList) => {
  return valueList.map((key) => obj[key]).join('-');
};
</script>
